import { AnimalSplitType } from '@farmshare/utils';

import { CutsheetInfo, SplitSlotDef } from './types';

export function getSplitSlots(splitType: AnimalSplitType): SplitSlotDef[] {
  switch (splitType) {
    case 'whole':
      return [{ label: 'Whole', part: 'whole' }];
    case 'half':
      return [
        { label: 'Half 1', part: 'half' },
        { label: 'Half 2', part: 'half' },
      ];
    case 'quarters':
      return [
        { label: 'Quarter 1', part: 'quarter' },
        { label: 'Quarter 2', part: 'quarter' },
        { label: 'Quarter 3', part: 'quarter' },
        { label: 'Quarter 4', part: 'quarter' },
      ];
    case 'half_and_two_quarters':
      return [
        { label: 'Half', part: 'half' },
        { label: 'Quarter 1', part: 'quarter' },
        { label: 'Quarter 2', part: 'quarter' },
      ];
    default:
      return [];
  }
}

export function chunkSlots(slots: SplitSlotDef[]): SplitSlotDef[][] {
  const rows: SplitSlotDef[][] = [];
  for (let i = 0; i < slots.length; i += 2) {
    rows.push(slots.slice(i, i + 2));
  }
  return rows;
}

export function getSplitDescription(splitType: string): string {
  switch (splitType) {
    case 'whole':
      return 'Entire animal to one buyer';
    case 'half':
      return 'Split between two buyers';
    case 'quarters':
      return 'Split between four buyers';
    case 'half_and_two_quarters':
      return 'One half and two quarters';
    default:
      return '';
  }
}

export function getBuyerDisplayName(
  buyer: NonNullable<CutsheetInfo>['contactUser'],
): string {
  if (buyer?.first_name || buyer?.last_name) {
    return [buyer.first_name, buyer.last_name].filter(Boolean).join(' ');
  }
  return '';
}

type QuestionnaireRef =
  | string
  | { _id?: string | null; id?: string | null; capabilityId?: string | null }
  | null
  | undefined;

export function getQuestionnaireId(value: QuestionnaireRef): string | null {
  if (!value) return null;
  if (typeof value === 'string') return value;
  if (typeof value === 'object') {
    if (value._id) return value._id;
    if (value.id) return value.id;
  }
  return null;
}

export function getQuestionnaireCapabilityId(
  value: QuestionnaireRef,
): string | null {
  if (!value || typeof value === 'string') return null;
  if (typeof value === 'object' && value.capabilityId) {
    return value.capabilityId;
  }
  return null;
}
